import React from 'react';
import { useTranslation } from 'react-i18next';

const M1LinkTipContent = () => {
  const { t } = useTranslation();
  return (
    <p>{t('m1Ti2')}</p>
  );
};

export default M1LinkTipContent;
